'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M19.59 7L12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9z' });

var CallMissed = function CallMissed(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

CallMissed = (0, _pure2.default)(CallMissed);
CallMissed.muiName = 'SvgIcon';

exports.default = CallMissed;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/CallMissed.js
// module id = 2219
// module chunks = 0